export const environment = {
  production: true,
  useEmulators: false,
  database: 'production',
  firebaseEnv: {
    apiKey: "AIzaSyBRyI3wIMkmq7TcyL7t-TORw_UaiuYrMQc",
    authDomain: "rewirenpc.firebaseapp.com",
    databaseURL: "https://rewirenpc.firebaseio.com",
    projectId: "rewirenpc",
    storageBucket: "rewirenpc.appspot.com",
    messagingSenderId: "203397110020",
    appId: "1:203397110020:web:d18c87b3e9bcb462081851",
    measurementId: "G-YCG3LKDSZS"

  },
  appCheck: {
    siteKey: '6LccQ7UsAAAAAJZeVcoyOa2YVOxblpkeicbdcPPJ'
  },
  previewUrl: 'https://npcadmin.collegeboard.org/preview/app/',
  functionsURL: `https://us-central1-rewirenpc.cloudfunctions.net/`
};
